import React from 'react';
import { useLocation } from 'react-router-dom';
import { SECTION_NAMES } from '@constants/sectionNames';
import { DateString, NumberString, PriceString } from '@fourthwall/components';
import { AnalyticsCard } from '../../analyticsModule/components/AnalyticsCard/AnalyticsCard';
import { createReportLink } from '../../utils/createReportLink';
export const OverviewAnalytics = () => {
    const formatPrice = (value) => React.createElement(PriceString, { value: value });
    const formatDate = (value) => React.createElement(DateString, { date: value });
    const formatNumber = (value) => React.createElement(NumberString, { value: value });
    const location = useLocation();
    const getReportLink = createReportLink({ label: SECTION_NAMES.analytics, location });
    return (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsCard, { type: "lineChart", title: "Shop profit", titleTooltip: "Something", reportLink: getReportLink('shop-profit'), value: [26896.1, 23896.34], formatValue: formatPrice, formatXAxis: formatDate, data: [
                {
                    label: 'Sprzedaż',
                    data: [
                        { value: 100, label: '2023-01-01T00:00:00Z' },
                        { value: 150, label: '2023-02-15T00:00:00Z' },
                        { value: 200, label: '2023-03-01T00:00:00Z' },
                        { value: 180, label: '2023-04-15T00:00:00Z' },
                        { value: 250, label: '2023-05-01T00:00:00Z' },
                        { value: 300, label: '2023-06-15T00:00:00Z' },
                        { value: 280, label: '2023-07-01T00:00:00Z' },
                        { value: 320, label: '2023-08-15T00:00:00Z' },
                        { value: 350, label: '2023-09-01T00:00:00Z' },
                        { value: 400, label: '2023-10-15T00:00:00Z' },
                        { value: 300, label: '2023-11-01T00:00:00Z' },
                        { value: 308, label: '2023-12-15T00:00:00Z' },
                        { value: 199, label: '2024-01-01T00:00:00Z' },
                        { value: 298, label: '2024-02-15T00:00:00Z' },
                        { value: 345, label: '2024-03-01T00:00:00Z' },
                        { value: 328, label: '2024-04-15T00:00:00Z' },
                        { value: 403, label: '2024-05-01T00:00:00Z' },
                        { value: 495, label: '2024-06-15T00:00:00Z' },
                    ],
                },
                {
                    label: 'Zysk',
                    data: [
                        { value: 208, label: '2023-01-01T00:00:00Z' },
                        { value: 290, label: '2023-02-15T00:00:00Z' },
                        { value: 303, label: '2023-03-01T00:00:00Z' },
                        { value: 456, label: '2023-04-15T00:00:00Z' },
                        { value: 400, label: '2023-05-01T00:00:00Z' },
                        { value: 403, label: '2023-06-15T00:00:00Z' },
                        { value: 448, label: '2023-07-01T00:00:00Z' },
                        { value: 360, label: '2023-08-15T00:00:00Z' },
                        { value: 404, label: '2023-09-01T00:00:00Z' },
                        { value: 299, label: '2023-10-15T00:00:00Z' },
                        { value: 302, label: '2023-11-01T00:00:00Z' },
                        { value: 210, label: '2023-12-15T00:00:00Z' },
                        { value: 225, label: '2024-01-01T00:00:00Z' },
                        { value: 240, label: '2024-02-15T00:00:00Z' },
                        { value: 260, label: '2024-03-01T00:00:00Z' },
                        { value: 245, label: '2024-04-15T00:00:00Z' },
                        { value: 275, label: '2024-05-01T00:00:00Z' },
                        { value: 290, label: '2024-06-15T00:00:00Z' },
                    ],
                },
            ] }),
        React.createElement(AnalyticsCard, { type: "barChart", title: "Payment method used", titleTooltip: "Something", reportLink: getReportLink('payment-methods'), data: [
                {
                    label: React.createElement("a", { href: "https://google.com" }, "Next Level Supersoft T-Shirt"),
                    value: [3592, 3789],
                },
                {
                    label: 'Cotton Heritage Unisex Premium Hoodie',
                    value: [2961, 2874],
                },
                {
                    label: 'Unisex Sponge Fleece Raglan Sweatshirt',
                    value: [2584, 1937],
                },
                {
                    label: 'Unisex Midweight Dyed Sweatshirt',
                    value: [1945, 1945],
                },
            ], formatValue: formatNumber }),
        React.createElement(AnalyticsCard, { type: "stats", externalSource: "googleAnalytics", title: "Sales by country", titleTooltip: "Something", reportLink: getReportLink('sales-by-country'), data: [
                {
                    label: React.createElement("a", { href: "https://google.com" }, "Next Level Supersoft T-Shirt"),
                    value: [3592, 3789],
                },
                {
                    label: 'Cotton Heritage Unisex Premium Hoodie',
                    value: [2961, 2874],
                },
                {
                    label: 'Unisex Sponge Fleece Raglan Sweatshirt',
                    value: [2584, 9937],
                },
                {
                    label: 'Unisex Midweight Dyed Sweatshirt',
                    value: [1945, 1945],
                },
                {
                    label: 'Triblend Short Sleeve T-Shirt',
                    value: [1289, 1200],
                },
                {
                    label: 'Lane Seven Premium Pullover Hoodie',
                    value: [957, 765],
                },
            ], formatValue: formatNumber }),
        React.createElement(AnalyticsCard, { type: "lineChart", title: "Shop profit 2", titleTooltip: "Something", reportLink: getReportLink('shop-profit'), value: 26896.1, formatValue: formatPrice, formatXAxis: formatDate, data: [
                {
                    label: 'Sprzedaż',
                    data: [
                        { value: 100, label: '2023-01-01T00:00:00Z' },
                        { value: 150, label: '2023-02-15T00:00:00Z' },
                        { value: 200, label: '2023-03-01T00:00:00Z' },
                        { value: 180, label: '2023-04-15T00:00:00Z' },
                        { value: 250, label: '2023-05-01T00:00:00Z' },
                        { value: 300, label: '2023-06-15T00:00:00Z' },
                        { value: 280, label: '2023-07-01T00:00:00Z' },
                        { value: 320, label: '2023-08-15T00:00:00Z' },
                        { value: 350, label: '2023-09-01T00:00:00Z' },
                        { value: 400, label: '2023-10-15T00:00:00Z' },
                        { value: 300, label: '2023-11-01T00:00:00Z' },
                        { value: 308, label: '2023-12-15T00:00:00Z' },
                        { value: 199, label: '2024-01-01T00:00:00Z' },
                        { value: 298, label: '2024-02-15T00:00:00Z' },
                        { value: 345, label: '2024-03-01T00:00:00Z' },
                        { value: 328, label: '2024-04-15T00:00:00Z' },
                        { value: 403, label: '2024-05-01T00:00:00Z' },
                        { value: 495, label: '2024-06-15T00:00:00Z' },
                    ],
                },
            ] }),
        React.createElement(AnalyticsCard, { type: "barChart", title: "Top product", titleTooltip: "Something", reportLink: getReportLink('payment-methods'), data: [
                {
                    label: React.createElement("a", { href: "https://google.com" }, "Next Level Supersoft T-Shirt"),
                    value: 3592,
                },
                {
                    label: 'Cotton Heritage Unisex Premium Hoodie',
                    value: 2961,
                },
                {
                    label: 'Unisex Sponge Fleece Raglan Sweatshirt',
                    value: 2584,
                },
                {
                    label: 'Unisex Midweight Dyed Sweatshirt',
                    value: 1945,
                },
            ], formatValue: formatNumber }),
        React.createElement(AnalyticsCard, { type: "stats", externalSource: "googleAnalytics", title: "Sales by country", titleTooltip: "Something", reportLink: getReportLink('sales-by-country'), data: [
                {
                    label: React.createElement("a", { href: "https://google.com" }, "Next Level Supersoft T-Shirt"),
                    value: 3592,
                },
                {
                    label: 'Cotton Heritage Unisex Premium Hoodie',
                    value: 2961,
                },
                {
                    label: 'Unisex Sponge Fleece Raglan Sweatshirt',
                    value: 2584,
                },
                {
                    label: 'Unisex Midweight Dyed Sweatshirt',
                    value: 1945,
                },
                {
                    label: 'Triblend Short Sleeve T-Shirt',
                    value: 1289,
                },
                {
                    label: 'Lane Seven Premium Pullover Hoodie',
                    value: 957,
                },
            ], formatValue: formatNumber }),
        React.createElement(AnalyticsCard, { type: "lineChart", title: "Shop profit", titleTooltip: "Something", reportLink: "https://www.google.com", value: [200, 220], isLoading: true, data: [
                {
                    label: 'Sprzedaż',
                    data: [
                        { value: 100, label: '2023-01-01T00:00:00Z' },
                        { value: 150, label: '2023-02-15T00:00:00Z' },
                        { value: 200, label: '2023-03-01T00:00:00Z' },
                        { value: 180, label: '2023-04-15T00:00:00Z' },
                        { value: 250, label: '2023-05-01T00:00:00Z' },
                        { value: 300, label: '2023-06-15T00:00:00Z' },
                        { value: 280, label: '2023-07-01T00:00:00Z' },
                        { value: 320, label: '2023-08-15T00:00:00Z' },
                        { value: 350, label: '2023-09-01T00:00:00Z' },
                        { value: 400, label: '2023-10-15T00:00:00Z' },
                        { value: 380, label: '2023-11-01T00:00:00Z' },
                        { value: 420, label: '2023-12-15T00:00:00Z' },
                        { value: 450, label: '2024-01-01T00:00:00Z' },
                        { value: 480, label: '2024-02-15T00:00:00Z' },
                        { value: 520, label: '2024-03-01T00:00:00Z' },
                        { value: 490, label: '2024-04-15T00:00:00Z' },
                        { value: 550, label: '2024-05-01T00:00:00Z' },
                        { value: 580, label: '2024-06-15T00:00:00Z' },
                    ],
                },
                {
                    label: 'Zysk',
                    data: [
                        { value: 50, label: '2023-01-01T00:00:00Z' },
                        { value: 75, label: '2023-02-15T00:00:00Z' },
                        { value: 100, label: '2023-03-01T00:00:00Z' },
                        { value: 90, label: '2023-04-15T00:00:00Z' },
                        { value: 125, label: '2023-05-01T00:00:00Z' },
                        { value: 150, label: '2023-06-15T00:00:00Z' },
                        { value: 140, label: '2023-07-01T00:00:00Z' },
                        { value: 160, label: '2023-08-15T00:00:00Z' },
                        { value: 175, label: '2023-09-01T00:00:00Z' },
                        { value: 200, label: '2023-10-15T00:00:00Z' },
                        { value: 190, label: '2023-11-01T00:00:00Z' },
                        { value: 210, label: '2023-12-15T00:00:00Z' },
                        { value: 225, label: '2024-01-01T00:00:00Z' },
                        { value: 240, label: '2024-02-15T00:00:00Z' },
                        { value: 260, label: '2024-03-01T00:00:00Z' },
                        { value: 245, label: '2024-04-15T00:00:00Z' },
                        { value: 275, label: '2024-05-01T00:00:00Z' },
                        { value: 290, label: '2024-06-15T00:00:00Z' },
                    ],
                },
            ] }),
        React.createElement(AnalyticsCard, { type: "barChart", title: "Payment method used", titleTooltip: "Something", reportLink: "https://www.google.com", isLoading: true, formatValue: formatPrice, data: [] }),
        React.createElement(AnalyticsCard, { type: "stats", externalSource: "googleAnalytics", title: "Sales by country", titleTooltip: "Something", reportLink: "https://www.google.com", isLoading: true, data: [
                {
                    label: React.createElement("a", { href: "https://google.com" }, "Next Level Supersoft T-Shirt"),
                    value: 3592,
                },
                {
                    label: 'Cotton Heritage Unisex Premium Hoodie',
                    value: 2961,
                },
                {
                    label: 'Unisex Sponge Fleece Raglan Sweatshirt',
                    value: 2584,
                },
                {
                    label: 'Unisex Midweight Dyed Sweatshirt',
                    value: 1947,
                },
                {
                    label: 'Triblend Short Sleeve T-Shirt',
                    value: 1289,
                },
                {
                    label: 'Lane Seven Premium Pullover Hoodie',
                    value: 957,
                },
            ] })));
};
